import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, Input, OnInit, QueryList, Renderer2, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { MenuDropdownElemComponent } from '../menu-dropdown-elem/menu-dropdown-elem.component';
import { MenuDropdownNavComponent } from '../menu-dropdown-nav/menu-dropdown-nav.component';


@Component({
  selector: 'neo-menu-dropdown',
  templateUrl: './menu-dropdown.component.html',
  styleUrls: ['./menu-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuDropdownComponent implements OnInit, AfterViewInit {
  @ViewChild(MenuDropdownNavComponent) menuDropdownNav: MenuDropdownNavComponent;


  @Input() elementos = [];
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (!this.document.body.classList.contains('menu-mobile')) {
      // console.log('[MENU ] Menu desktop');
      // console.log('[MENU ] Recorremos los menuDropElement ');
      // console.log('[MENU ] ', this.menuDropdownNav.menuDropElem.length);
      // if (this.menuDropdownNav?.menuDropElem && this.menuDropdownNav.menuDropElem.length > 0) {
      //   this.menuDropdownNav?.menuDropElem.forEach((item, index, arr) => console.log('[Menu elem]',item));
      // }
    }else {
      // console.log('[MENU ] Menu movil');
    }

  }

}
